import React from 'react';
import PropTypes from 'prop-types';
import {EmptyHolder} from './EmptyHolder';
import {DroppedNode} from './DroppedNode';
import './style.scss';

const OPTION_ID = 'optionID';

/**
 * HexagonNodeHolder: Component that holds a hexagon node
 */
export function HexagonNodeHolder(props) {
  const onComponentDrop = (event) => {
    const optionID = parseInt(event.dataTransfer.getData(OPTION_ID));
    props.dropItem({
      optionID,
      positionId: props.positionId,
    });
  };

  const onRemoveCard = () => {
    if (props.removeCard) {
      props.removeCard(props.positionId);
    }
  };

  const isUndropped = () => props.droppedId === null;

  const isCorrect = () => props.droppedId === props.positionId;

  if (props.current && isUndropped()) {
    return <EmptyHolder onComponentDrop={onComponentDrop} />;
  } else if (isUndropped()) {
    return null;
  } else {
    return (
      <DroppedNode
        correct={isCorrect()}
        onRemoveCard={onRemoveCard}
        image={props.image}
        modal={props.modal}
        title={props.title}
        errorMessage={props.feedbackMessage}
      />
    );
  }
}

HexagonNodeHolder.propTypes = {
  /**
   * Name of component to display in placeholder
   */
  componentName: PropTypes.string,
  /**
   * To specify if current component in focus
   */
  current: PropTypes.bool.isRequired,
  /**
   * UniqueID of the component current dropped in position
   */
  droppedId: PropTypes.number,
  /**
   * Function to invoke when an item in dropped in placeholder
   */
  dropItem: PropTypes.func,
  /**
   * UniqueID of the component intended to be placed in this position
   */
  positionId: PropTypes.number.isRequired,
  /**
   * Type of Component intended for the position, Always LINK_HEXAGON_MODAL
   */
  type: PropTypes.oneOf(['LINK_HEXAGON_MODAL']),
  /**
   * callback function to be executed when card needs to be removed from design section tree
   */
  removeCard: PropTypes.func,
  /**
   * Url to the small card icon image
   */
  image: PropTypes.string,
  /**
   * Title of the card
   */
  title: PropTypes.string,
  /**
   * Data to be displayed in the modal
   */
  modal: PropTypes.object,
  /**
   * feedback message to be displayed on tooltip
   */
  feedbackMessage: PropTypes.string,
};

HexagonNodeHolder.defaultProps = {
  componentName: null,
  current: false,
  droppedId: null,
  positionId: null,
  type: 'LINK_HEXAGON_MODAL',
  removeCard: undefined,
};
